import { Spacings, View } from "react-native-ui-lib";
import { ModalCloseButton } from "@towersystems/roam-common-native";

export interface CameraHeaderProps {
  showBackButton?: boolean;
  rightComponent?: JSX.Element;
}

export function CameraHeader({
  showBackButton = true,
  rightComponent,
}: CameraHeaderProps) {
  return (
    <View
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        width: "100%",
        height: 65,
        zIndex: 1,
        paddingLeft: Spacings.s5,
        paddingRight: Spacings.s5,
        justifyContent: "center",
      }}
    >
      {showBackButton && (
        <View>
          <ModalCloseButton type="Back" />
        </View>
      )}
      {rightComponent && (
        <View
          style={{
            display: "flex",
            marginLeft: "auto",
          }}
        >
          {rightComponent}
        </View>
      )}
    </View>
  );
}
